module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "master-category-list"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Stock"
    }
  }, [_vm._v(_vm._s(_vm.$t('Stock')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/master_stock"
    }
  }, [_vm._v(_vm._s(_vm.$t('Master Stock')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Master Category')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('a', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.goCategoryNew()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('New Registration')))])])])]), _c('div', [((_vm.categories != null && _vm.categories.length > 0) && _vm.searchCallbackFlag) ? _c('div', [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', {
    staticClass: "info"
  }, [_c('th', {
    staticClass: "col-sm-10",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('category.label.name')))])])]), _c('tbody', _vm._l((_vm.categories), function(category, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(category.name))]), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('a', {
      staticClass: "btn btn-info btn-sm margin-right",
      on: {
        "click": function($event) {
          _vm.goCategoryEdit(category.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('Edit')))]), _c('a', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          _vm.categoryDelete(category.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('Delete')))])])])
  }))])])])]) : _vm._e(), ((_vm.categories == null || _vm.categories.length <= 0) && _vm.searchCallbackFlag) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('No Data')))])])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6fade794!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/master-category-list.pug
// module id = 873
// module chunks = 1